import React, { useEffect, useState } from 'react'
import { useQuery } from '@apollo/client'
import { GET_ALL_PACKAGE_AND_FEATURES_LIST } from '../../../../../graphql/query'
import LoadingSpinner from '../../../../../components/LoadingSpinner'
import { Modal } from 'antd'
import SelectedPlanAmount from './SelectedPlanAmount'

interface IProps {
  closeModal: any
  isPaymentDetails: any
  nextStep: any
  isProfile: boolean
}

const UpdatePlan: React.FC<IProps> = ({ closeModal, isPaymentDetails, nextStep, isProfile }) => {
  const [selectedPackageId, setSelectedPackageId] = useState<string | null>(null)
  const [packageData, setPackageData] = useState<any[]>([]) // Updated to correctly type as an array of any
  const [isSelectedPlanModalOpen, setIsSelectedPlanModalOpen] = useState<boolean>(false)
  const [selectedPlanName, setSelectedPlanName] = useState<any>('')

  const { error, loading, data } = useQuery(GET_ALL_PACKAGE_AND_FEATURES_LIST, {
    context: {
      headers: {
        'access-control-allow-methods': !isProfile ? 'Accounts' : 'Clients'
      }
    }
  })

  useEffect(() => {
    if (data) {
      const fetchedPackageData = data?.getAllPackageAndFeturesList?.data || []
      // Filter out the package with the same packageName as isPaymentDetails.clientPackage.package.package.packageName
      const filteredPackageData = fetchedPackageData.filter(
        (packageItem: any) => packageItem.package?.packageName
      )
      setPackageData(filteredPackageData) // Set packageData to filtered data
    }
  }, [data])

  if (error) {
    console.log(error)
  }
  if (loading) {
    return <LoadingSpinner />
  }

  const handlePlanFilterChange = (value: string | null, packageId: string | null) => {
    setSelectedPackageId(packageId)
    setSelectedPlanName(value)
  }

  const submitHandler = () => {
    // Handle submit logic
    selectPlanModalOpen()
  }

  const selectPlanModalOpen = () => {
    setIsSelectedPlanModalOpen(true)
  }

  const selectedPlanHandleOk = () => {
    setIsSelectedPlanModalOpen(false)
  }

  const selectedPlanCancel = () => {
    setIsSelectedPlanModalOpen(false)
  }

  const isSubmitDisabled = !selectedPackageId

  console.log(isPaymentDetails)

  return (
    <>
      <div className='d-flex flex-column w-100 mt-8'>
        <div className='d-flex align-items-center w-100 mt-4'>
          <label className='w-25 fw-bolder'>Updated Plan</label>
          <div className='d-flex flex-column w-75'>
            <select
              className='form-select form-select-solid form-select'
              name='Department'
              onChange={(e) =>
                handlePlanFilterChange(
                  e.target.value !== 'Select' ? e.target.value : null,
                  e.target.selectedOptions[0].id
                )
              }
            >
              <option key='blankKey' value='Select' hidden>
                Select
              </option>

              {packageData?.map((packageItem: any, index: number) => (
                <option
                  key={index}
                  value={packageItem.package?.packageType?.typeName}
                  id={packageItem?.package?.PackageFeature[0]?.packageFeatureId}
                >
                  {packageItem.package?.packageName} {/* Display packageName */}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className='d-flex justify-content-end mt-2'>
          <p>
            <button
              className={`btn btn-primary ${isSubmitDisabled ? 'disabled' : ''}`}
              onClick={submitHandler}
              disabled={isSubmitDisabled}
            >
              Submit
            </button>
          </p>
        </div>
      </div>

      <Modal
        title=''
        open={isSelectedPlanModalOpen}
        onOk={selectedPlanHandleOk}
        onCancel={selectedPlanCancel}
        footer={false}
        destroyOnClose
      >
        <SelectedPlanAmount
          closeModal={selectedPlanCancel}
          isPaymentDetails={isPaymentDetails}
          selectedPackageId={selectedPackageId}
          selectedPlanName={selectedPlanName}
          selectedPlanCancel={selectedPlanCancel}
          nextStep={nextStep}
          isProfile={isProfile}
        />
      </Modal>
    </>
  )
}

export default UpdatePlan
